export default __webpack_public_path__ + "static/media/logo-white.55ae293d.svg";